// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_requestAvatarUploadV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["UploadV5"]);
}

let variablesConverter = {"avatarUploadInput":{},"__root":{"input":{"r":"avatarUploadInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"requestAvatarUploadV5":{"u":"response_requestAvatarUploadV5"}}};

let wrapResponseConverterMap = {
  response_requestAvatarUploadV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"requestAvatarUploadV5":{"u":"response_requestAvatarUploadV5"}}};

let responseConverterMap = {
  response_requestAvatarUploadV5: unwrap_response_requestAvatarUploadV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "requestAvatarUploadV5",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contentType",
            "storageKey": null
          }
        ],
        "type": "UploadV5",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AvatarUploadProvider_RequestAvatarUploadV5Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AvatarUploadProvider_RequestAvatarUploadV5Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9739fdf2e0c459722d9a817248528036",
    "id": null,
    "metadata": {},
    "name": "AvatarUploadProvider_RequestAvatarUploadV5Mutation",
    "operationKind": "mutation",
    "text": "mutation AvatarUploadProvider_RequestAvatarUploadV5Mutation(\n  $input: AvatarUploadInput!\n) {\n  requestAvatarUploadV5(input: $input) {\n    __typename\n    ... on UploadV5 {\n      id\n      fileName\n      url\n      key\n      contentType\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_requestAvatarUploadV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_requestAvatarUploadV5 = unwrap_response_requestAvatarUploadV5;
exports.wrap_response_requestAvatarUploadV5 = wrap_response_requestAvatarUploadV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
